import _ from "lodash";
// 保存search参数到localStorage
export const saveSearchParams = obj => {
  window.localStorage.setItem("selectedSearch", JSON.stringify(obj));
};
// 获取localStorage数据
export const searchParamsCache = window.localStorage.getItem("selectedSearch") ?
  JSON.parse(window.localStorage.getItem("selectedSearch")) : null;

// 显示多选cinemaName
export const displayMultiCinemaNames = (cinemaIds, list) => {
  const names = _.map(cinemaIds, id => {
    const item = _.find(list, { id });
    return item ? item.name : null;
  }).filter(name => name !== null);
  return _.join(names, ", ");
};
// 周文字数据
const dayList = ["日", "月", "火", "水", "木", "金", "土"];
// 格式化年月日期
export const formatReportDate = (start, end) => {
  const reportStartDate = start;
  const startDay = dayList[new Date(reportStartDate).getDay()];
  const reportEndDate = end;
  const endDay = dayList[new Date(reportEndDate).getDay()];
  return `${reportStartDate} (${startDay}) ~ ${reportEndDate} (${endDay})`;
};
// 格式化数据
// カード合計 = VISA/MASTER + JCB/AMEX/Diners + PayPay（backend cardTotal 未含 PayPay，DEV-11231）
const sumCardTotal = row => (row.vmCardTotal || 0) + (row.jadCardTotal || 0) + (row.paypayTotal || 0);
export const formatResponseData = (records, grandTotal) => {
  const allTotal_sum = row => {
    const { allTotal } = row;
    const visitor = !_.isEmpty(allTotal) ? Object.values(allTotal).reduce((acc, current) => acc + current.visitor, 0) : 0;
    const total = !_.isEmpty(allTotal) ? Object.values(allTotal).reduce((acc, current) => acc + current.total, 0) : 0;
    return { visitor, total };
  };
  const grandAllTotal_sum = records => {
    const visitor = _.sumBy(records, "boxOfficelateShow_visitorTotal");
    const total = _.sumBy(records, "boxOfficelateShow_total");
    return { visitor, total };
  };
  const _records = records.map((item, idx) => ({
    sort: idx + 1,
    cinemaName: item.cinemaName,
    commissionFees_visitor: item.commissionFees.visitor,
    commissionFees_total: item.commissionFees.total,
    commissionFees_seatVisitor: item.commissionFees.seatVisitor,
    commissionFees_seatTotal: item.commissionFees.seatTotal,
    commissionFees_allTotal: item.commissionFees.allTotal,
    commissionFees_allTotalFee: item.commissionFees.allTotalFee,
    completedSales_salesTotal: item.completedSales.salesTotal,
    completedSales_allTotal: item.completedSales.allTotal,
    refundedSales_salesTotal: item.refundedSales.salesTotal,
    refundedSales_allTotal: item.refundedSales.allTotal,
    total: item.total,
    vmCardTotal: item.vmCardTotal,
    vmCardTotalFee: item.vmCardTotalFee,
    jadCardTotal: item.jadCardTotal,
    jadCardTotalFee: item.jadCardTotalFee,
    paypayTotal: item.paypayTotal,
    paypayTotalFee: item.paypayTotalFee,
    cardTotal: sumCardTotal(item),
    boxOffice_visitor: ((item.allTotal || {}).boxOffice || {}).visitor || null,
    boxOffice_total: ((item.allTotal || {}).boxOffice || {}).total || null,
    morningShow_visitor: ((item.allTotal || {}).morningShow || {}).visitor || null,
    morningShow_total: ((item.allTotal || {}).morningShow || {}).total || null,
    lateShow_visitor: ((item.allTotal || {}).lateShow || {}).visitor || null,
    lateShow_total: ((item.allTotal || {}).lateShow || {}).total || null,
    allNight_visitor: ((item.allTotal || {}).allNight || {}).visitor || null,
    allNight_total: ((item.allTotal || {}).allNight || {}).total || null,
    allSales_allTotal: item.allSales.allTotal,
    allSales_allTotalFee: item.allSales.allTotalFee,
    allSales_salesTotal: item.allSales.salesTotal,
    allSales_salesTotalFee: item.allSales.salesTotalFee,
    specialBusiness_visitor: ((item.allTotal || {}).special || {}).visitor || 0,
    specialBusiness_total: ((item.allTotal || {}).special || {}).total || 0,
    boxOfficelateShow_visitorTotal: allTotal_sum(item).visitor,
    boxOfficelateShow_total: allTotal_sum(item).total,
    advanceTicket_visitor: (function () {
      const v = ((item.allTotal || {}).advanceTicket || {}).visitor;
      return v != null ? v : null;
    })(),
    advanceTicket_total: (function () {
      const at = (item.allTotal || {}).advanceTicket || {};
      const t = at.total;
      return t != null ? t : (at.amount != null ? at.amount : null);
    })(),
    nationalTicket_visitor: ((item.allTotal || {}).nationalTicket || {}).visitor || null,
    nationalTicket_total: ((item.allTotal || {}).nationalTicket || {}).total || null,
    ticket_total: (function () {
      const at = (item.allTotal || {}).advanceTicket || {};
      const nt = (item.allTotal || {}).nationalTicket || {};
      return (at.total != null ? at.total : (at.amount != null ? at.amount : 0)) + (nt.total != null ? nt.total : 0);
    })(),
    freeHoldSeatPayedCount: item.freeHoldSeatPayedCount,
    freeHoldSeatPendingCount: item.freeHoldSeatPendingCount,
    freeHoldSeatPayedFee: item.freeHoldSeatPayedFee,
  }));
  const data_arr = JSON.parse(JSON.stringify(_records));
  _records.push({
    sort: "",
    cinemaName: "合計（全て）",
    commissionFees_visitor: grandTotal.commissionFees.visitor,
    commissionFees_total: grandTotal.commissionFees.total,
    commissionFees_seatVisitor: grandTotal.commissionFees.seatVisitor,
    commissionFees_seatTotal: grandTotal.commissionFees.seatTotal,
    commissionFees_allTotal: grandTotal.commissionFees.allTotal,
    commissionFees_allTotalFee: grandTotal.commissionFees.allTotalFee,
    completedSales_salesTotal: grandTotal.completedSales.salesTotal,
    completedSales_allTotal: grandTotal.completedSales.allTotal,
    refundedSales_salesTotal: grandTotal.refundedSales.salesTotal,
    refundedSales_allTotal: grandTotal.refundedSales.allTotal,
    total: grandTotal.gmoTotal,
    vmCardTotal: grandTotal.vmCardTotal,
    vmCardTotalFee: grandTotal.vmCardTotalFee,
    jadCardTotal: grandTotal.jadCardTotal,
    jadCardTotalFee: grandTotal.jadCardTotalFee,
    paypayTotal: grandTotal.paypayTotal,
    paypayTotalFee: grandTotal.paypayTotalFee,
    cardTotal: sumCardTotal(grandTotal),
    boxOffice_visitor: (grandTotal.boxOffice || {}).visitor || null,
    boxOffice_total: (grandTotal.boxOffice || {}).total || null,
    morningShow_visitor: (grandTotal.morningShow || {}).visitor || null,
    morningShow_total: (grandTotal.morningShow || {}).total || null,
    lateShow_visitor: (grandTotal.lateShow || {}).visitor || null,
    lateShow_total: (grandTotal.lateShow || {}).total || null,
    allNight_visitor: (grandTotal.allNight || {}).visitor || null,
    allNight_total: (grandTotal.allNight || {}).total || null,
    allSales_allTotal: (grandTotal.allSales || {}).allTotal || null,
    allSales_allTotalFee: (grandTotal.allSales || {}).allTotalFee || null,
    allSales_salesTotal: (grandTotal.allSales || {}).salesTotal || null,
    allSales_salesTotalFee: (grandTotal.allSales || {}).salesTotalFee || null,
    specialBusiness_visitor: (grandTotal.special || {}).visitor || null,
    specialBusiness_total: (grandTotal.special || {}).total || null,
    boxOfficelateShow_visitorTotal: grandAllTotal_sum(data_arr).visitor,
    boxOfficelateShow_total: grandAllTotal_sum(data_arr).total,
    advanceTicket_visitor: (function () {
      const v = (grandTotal.advanceTicket || {}).visitor;
      return v != null ? v : null;
    })(),
    advanceTicket_total: (function () {
      const at = grandTotal.advanceTicket || {};
      const t = at.total;
      return t != null ? t : (at.amount != null ? at.amount : null);
    })(),
    nationalTicket_visitor: (grandTotal.nationalTicket || {}).visitor || null,
    nationalTicket_total: (grandTotal.nationalTicket || {}).total || null,
    ticket_total: (function () {
      const at = grandTotal.advanceTicket || {};
      const nt = grandTotal.nationalTicket || {};
      return (at.total != null ? at.total : (at.amount != null ? at.amount : 0)) + (nt.total != null ? nt.total : 0);
    })(),
    freeHoldSeatPendingCount: _records.reduce((prev, cur) => prev + cur.freeHoldSeatPendingCount, 0),
    freeHoldSeatPayedCount: _records.reduce((prev, cur) => prev + cur.freeHoldSeatPayedCount, 0),
    freeHoldSeatPayedFee: _records.reduce((prev, cur) => prev + cur.freeHoldSeatPayedFee, 0),
  });
  return _records;
};
